import { API } from "../../utility/API"

export const getWithdrawalFee = (currency) => {
    return API.post(`/trading/account/withdraws/estimate_fee?currency=${currency}`)
}

export const getOrderFee = (market, price, ord_type) => {
    return API.get(`/api/v2/trading/market/orders/estimate_fee?market=${market}&price=${price}&ord_type=${ord_type}`)
}

export const getConversionFee = (from_currency, to_currency, amount) => {
    return API.get(`/api/v2/trading/market/conversions/preview?from_currency=${from_currency}&to_currency=${to_currency}&amount=${amount}`)
} 